module.exports = __webpack_public_path__ + "img/00012.5eee090a.webp";